import { Col, Input, Row } from 'antd';
import { ErrorMessage, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';

import * as S from './styled';

interface CompanyFormProps {
  initialValues: any;
  loading: boolean;
  onSubmit: any;
  isEdit?: boolean;
}

const CompanyForm = ({
  initialValues,
  loading,
  onSubmit,
  isEdit,
}: CompanyFormProps) => {
  const history = useHistory();

  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validate={(values) => {
        const errors: any = {};

        if (!values.name) {
          errors.name = T('The company name field is required.');
        }

        if (!values.nit) {
          errors.nit = T('The NIT field is required.');
        }

        if (!values.sapCode) {
          errors.sapCode = T('The Sap Code field is required.');
        }

        return errors;
      }}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, setFieldValue, values }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Row gutter={24}>
              <Col md={12}>
                <S.Label>Nome da empresa</S.Label>

                <Input
                  name='name'
                  size='large'
                  disabled={loading}
                  onChange={(event) => {
                    setFieldValue('name', event.target.value);
                  }}
                  value={values.name}
                />

                <ErrorMessage name='name' component={S.MessageBox} />
              </Col>

              <Col md={12}>
                <S.Label>NIT</S.Label>

                <Input
                  name='nit'
                  size='large'
                  disabled={loading}
                  onChange={(event) => {
                    setFieldValue('nit', event.target.value);
                  }}
                  value={values.nit}
                />

                <ErrorMessage name='nit' component={S.MessageBox} />
              </Col>
            </Row>

            <Row gutter={24} style={{ marginTop: 24 }}>
              <Col md={12}>
                <S.Label>{T('Sap Code')}</S.Label>

                <Input
                  name='sapCode'
                  size='large'
                  disabled={loading}
                  onChange={(event) => {
                    setFieldValue('sapCode', event.target.value);
                  }}
                  value={values.sapCode}
                />

                <ErrorMessage name='sapCode' component={S.MessageBox} />
              </Col>
            </Row>

            <Row style={{ marginTop: 32, justifyContent: 'space-between' }}>
              <S.Button
                disabled={loading}
                size='large'
                danger
                onClick={() => {
                  history.goBack();
                }}
              >
                Cancelar
              </S.Button>

              <S.Button
                loading={loading}
                key='submit'
                size='large'
                type='primary'
                htmlType='submit'
              >
                {isEdit ? T('Update Company') : T('Create Company')}
              </S.Button>
            </Row>
          </form>
        );
      }}
    </Formik>
  );
};

export default CompanyForm;
